var _style;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoIris(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "Ebene_1",
    width: 234,
    height: 90,
    x: 0,
    y: 0,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2",
    type: "text/css"
  }, ".st1{fill-rule:evenodd;clip-rule:evenodd}.st1,.st2{fill:#1e3553}")), /*#__PURE__*/React.createElement("g", {
    id: "g29",
    transform: "translate(0 3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logomark"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4",
    d: "M49.4 27.8c0-9.2 7.5-16.6 16.6-16.6 9.2 0 16.6 7.5 16.6 16.6 0 9.2-7.5 16.6-16.6 16.6-9.2.1-16.6-7.4-16.6-16.6Z",
    style: {
      fill: "#708dad"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M37.3 23.1c2.5-.6 5.1-.9 7.6-1.2-.3 3.9-.3 7.9 0 11.8-2.6-.2-5.1-.5-7.6-1.2-.5-3.1-.5-6.3 0-9.4z",
    className: "st1",
    style: {
      clipRule: "evenodd",
      fill: "#1e3553",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M59.6 21.4c4.1-1.1 8.7-1.1 12.8 0 1.1 4.1 1.1 8.7 0 12.8-4.1 1.1-8.7 1.1-12.8 0-1.1-4.1-1.1-8.6 0-12.8z",
    className: "st1",
    style: {
      clipRule: "evenodd",
      fill: "#1e3553",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M87.1 21.9c2.6.2 5.1.5 7.6 1.2.4 3.2.4 6.4 0 9.5-2.5.6-5.1.9-7.6 1.2.3-4 .3-8 0-11.9z",
    className: "st1",
    style: {
      clipRule: "evenodd",
      fill: "#1e3553",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M13.1 26.3s14.2-23.1 46-24.2c31.8-1.1 46.5 24.4 46.5 24.4S87.2 4.3 56.2 5.6c-24.5 1-43.1 20.7-43.1 20.7z",
    className: "st1",
    style: {
      clipRule: "evenodd",
      fill: "#1e3553",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M101 32s-9.1 13.1-26.3 16.6c-14.1 2.8-25.3-.9-28.9-2.6-6.9-3.2-12.2-6.7-19.4-13.7 0 0 9.3 13.1 22.9 17.7 13.6 4.6 23.5 2.3 25.1 2.1 1.5-.3 18-3.9 26.6-20.1z",
    className: "st1",
    style: {
      clipRule: "evenodd",
      fill: "#1e3553",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "g27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M129.7 46.3h-7.2V9.2h7.2z",
    className: "st2",
    style: {
      fill: "#1e3553"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path19",
    d: "M160.1 46.3h-8.8l-9-15h-.1v15H135V9.2h9.8c7.3 0 12.4 3.2 12.4 11.2 0 4.7-2.6 9.4-7.6 10.3zm-17.9-20h.9c4 0 6.8-1.2 6.8-5.7 0-4.6-2.9-5.5-6.7-5.5h-1z",
    className: "st2",
    style: {
      fill: "#1e3553"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M169.7 46.3h-7.2V9.2h7.2z",
    className: "st2",
    style: {
      fill: "#1e3553"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path23",
    d: "M192.4 17.4c-1.4-1.9-3.1-3-5.6-3-2.3 0-4.5 1.8-4.5 4.2 0 6.2 14.7 3.6 14.7 16.1 0 7.4-4.6 12.7-12.2 12.7-5.1 0-8.9-3-11.4-7.2l4.7-4.6c1 2.9 3.6 5.4 6.7 5.4 3 0 4.8-2.5 4.8-5.4 0-3.8-3.5-4.9-6.4-6-4.8-2-8.3-4.4-8.3-10.1 0-6.1 4.6-11.1 10.8-11.1 3.3 0 7.9 1.6 10.1 4.1z",
    className: "st2",
    style: {
      fill: "#1e3553"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "path25",
    d: "M198.3 19.1c0-6.3 5-11.4 11.3-11.4 6.3 0 11.3 5 11.3 11.4s-5 11.4-11.3 11.4c-6.3 0-11.3-5.1-11.3-11.4zm2.5 0c0 5.1 4 8.9 8.8 8.9 4.8 0 8.8-3.8 8.8-8.9 0-5.1-4-8.9-8.8-8.9-4.8 0-8.8 3.8-8.8 8.9zm14.1 5.9h-2.7l-2.8-4.7h-2.1V25h-2.5V13.1h5.7c2.7 0 4.6.5 4.6 3.6 0 2.2-1.1 3.4-3.2 3.5zm-4.2-6.9c1.3 0 2.1-.3 2.1-1.6s-1.6-1.3-2.7-1.3h-2.7v2.9z",
    className: "st2",
    style: {
      fill: "#1e3553"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIris);
export default __webpack_public_path__ + "static/media/logo-iris.d70609720c82c6a7969757efdb6f2f00.svg";
export { ForwardRef as ReactComponent };